<template>
  <div>
    <top-nav-bar />
    <div v-if="error.statusCode === 401 && $userStore.user === null" class="my-3 container">
      <login @logged-in="logged_in" />
    </div>
    <div v-else class="my-4 container d-flex justify-content-center">
      <div class="card px-0 flex-grow-1" style="max-width: 500px; min-width: 400px">
        <div class="card-header">
          <h3 class="text-center">{{ tr(`Error`) }} [{{ error.statusCode }}]</h3>
        </div>
        <div class="card-body">
          <div class="text-center">
            <alert-circle-outline-icon class="icon-huge icon-muted" />
          </div>
          <h5 v-if="error.statusCode === 404" class="text-center">
            {{ tr(`Page not found`) }}
          </h5>
          <h5 v-else-if="error.statusCode === 401" class="text-center">
            {{ tr(`Unauthorized`) }}
          </h5>
          <h5 v-else class="text-center">
            {{ tr('An error has occurred') }}
          </h5>
          <div class="text-center">
            <nuxt-link to="/" class="mx-2">
              {{ tr(`Home`) }}
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopNavBar from '~/components/misc/TopNavBar.vue'
  import Login from '~/components/misc/Login.vue'
  import { clearError } from '#app'
  import { tr } from '~/assets/scripts/helpers'

  export default {
    components: { TopNavBar, Login },
    props: { error: { type: Object, required: true } },
    setup() {
      useHead({
        title: 'Error',
      })
      definePageMeta({
        layout: 'default',
      })
    },
    beforeMount() {
      if (this.$userStore.user === null && this.error.statusCode === 401) {
        useHead({ title: tr('Log In') })
      }
    },
    methods: {
      tr,
      logged_in() {
        clearError()
      },
    },
  }
</script>

<style scoped>
  .navbar-expand-md {
    height: 42px;
  }

  @media only screen and (max-width: 768px) {
    .navbar-expand-md {
      height: revert;
    }
  }

  .notification_banner {
    box-shadow: none;
    min-height: 31px;
    padding: 3px 20px 2px 20px;
    background-color: #585c63;
    color: #ffffff;
    text-align: center;
  }
</style>
